import { render } from "./Groups.vue?vue&type=template&id=ebdb88c6"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"

import "./Groups.vue?vue&type=style&index=0&id=ebdb88c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__